import type { Context } from '@nuxt/types';
import { LocaleObject } from 'nuxt-i18n';
import { SOLEPRO_STORE_CODE } from '~/utils/constants/store';

const findLocaleBasedOnMagentoStoreCode = (storeCode: string, locales: Array<string | LocaleObject>) => locales.find((locale) => ((typeof locale === 'object' ? locale.code : locale) === storeCode));

const findCurrencyBasedOnMagentoStoreCode = (storeCode: string, locales: Array<string | LocaleObject>): string => {
  const match = locales.find((locale) => typeof locale === 'object' && locale.code === storeCode) as LocaleObject | undefined;
  return match?.defaultCurrency;
};

export default ({ app, route }: Context) => app.$vsf.$magento.client.interceptors.request.use(async (request) => {
  const {
    $vsf: { $magento: { config: { state } } },
    i18n,
  } = app;

  state.setStore(SOLEPRO_STORE_CODE);
  state.setLocale(SOLEPRO_STORE_CODE);
  state.setCurrency('EUR');

  await i18n.setLocale(SOLEPRO_STORE_CODE);

  if (process.server) {
    const cookieHeader: any = request.headers.cookie || "";
    let cookies = cookieHeader.split("; ").reduce((acc, curr) => {
      const [name, val] = curr.split("=");
      acc[name] = val;
      return acc;
    }, {});

    cookies["24orepro-vsf-store"] = SOLEPRO_STORE_CODE;
    cookies["24orepro-vsf-locale"] = SOLEPRO_STORE_CODE;
    cookies["24orepro-vsf-currency"] = 'EUR';

    request.headers.cookie = Object.entries(cookies)
      .map(([key, val]) => `${key}=${val}`)
      .join("; ");
  }

  return request;
});
